import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import swal from 'sweetalert2';
import { CampPromoUploadService, SubscribeService } from '../../../services/index';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

@Component({
    selector: 'camp-promo-upload',
    templateUrl: './campPromoUpload.component.html',
})
export class CampPromoUploadComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    @ViewChild('fileUpload') fileUpload;

    isLoadMask: Promise<any>;
    excelData: any;
    rawFile: File = null;
    rawFileBase64: string = '';
    rawFileName: string = '';
    promoName: string = '';
    assignEmpId: number = 0;
    campPromoUserList: any[] = [];
    assignToCtrl: FormControl;
    isLoading: boolean = false;
    clientList = [];

    constructor(
        private campPromoUploadService: CampPromoUploadService,
        public subscribeService: SubscribeService
    ) {
        function hasValidAssignTo(input: FormControl) {
            const val = input.value;
            if (val && typeof val === 'string') {
                return { inValidAssignTo: true };
            }
            return null;
        }
        this.assignToCtrl = new FormControl('', [hasValidAssignTo]);
    }

    ngOnInit(): void {
        this.campPromoUploadService.getCampPromoUsers().then((res: any) => {
            if (res && res.success) {
                this.campPromoUserList = res.data;
            }
        });
    }

    displayAssignFn(userid: any): string {
        if (this.campPromoUserList && userid) {
            const found = this.campPromoUserList.find(u => String(u.userid) === String(userid));
            return found ? found.fullname : '';
        }
        return userid || '';
    }

    onAssignToSelected(userid: any) {
        this.assignEmpId = +userid || 0;
        setTimeout(() => {
            this.assignToCtrl.setValue(this.assignEmpId);
        });
    }

    clearAssignTo() {
        this.assignEmpId = 0;
        this.assignToCtrl.setValue('');
    }

    openWindow() {
        this.fileUpload.click();
    }

    downloadFile() {
        const todayDate = moment().format('DD-MM-YYYY');
        const ws = XLSX.utils.aoa_to_sheet([
            ['CLIENT ID', 'CLIENT NAME', 'MOBILE NUMBER', 'ADDRESS', 'DATE', 'STATUS', 'REFERENCE', 'BRANCH'],
            ['SG00001', 'Sample Client', '9876543210', 'Sample Address', todayDate, 'CAMP PROMO', 'ADVT-FACEBOOK', 'Branch Name']
        ]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        const fileName = 'CAMP_PROMO_Upload_' + moment().format('DD-MM-YYYY_HH-mm') + '.xlsx';
        XLSX.writeFile(wb, fileName);
    }

    uploadFile(sheet) {
        let workBook = null;
        let jsonData = null;
        const reader = new FileReader();
        if ((sheet.target.files.length == 0) || (sheet.target.files.length < 0)) {
            return;
        }
        const file = sheet.target.files[0];
        this.rawFile = file;
        reader.onload = (event) => {
            const data = reader.result;
            workBook = XLSX.read(data, { type: 'binary', cellDates: true });
            jsonData = workBook.SheetNames.reduce((initial, name) => {
                const sheet = workBook.Sheets[name];
                initial[name] = XLSX.utils.sheet_to_json(sheet);
                return initial;
            }, {});
            if (Object.keys(jsonData).length == 1) {
                for (let j = 0; j < jsonData.Sheet1.length; j++) {
                    if (jsonData.Sheet1[j].DATE && typeof jsonData.Sheet1[j].DATE === 'object') {
                        jsonData.Sheet1[j].CONV_DATE = moment(jsonData.Sheet1[j].DATE).format('DD-MM-YYYY');
                    } else if (jsonData.Sheet1[j].DATE) {
                        jsonData.Sheet1[j].CONV_DATE = jsonData.Sheet1[j].DATE;
                    } else {
                        jsonData.Sheet1[j].CONV_DATE = moment().format('DD-MM-YYYY');
                    }
                }
                this.excelData = JSON.stringify(jsonData);
                this.clientList = jsonData.Sheet1;
                // this.rawFileBase64 = btoa(data as string);
                this.rawFileName = file.name;
            } else {
                this.excelData = '';
                this.rawFile = null;
                // this.rawFileBase64 = '';
                this.rawFileName = '';
                sheet.srcElement.value = null;
                swal({ title: 'ERROR', text: 'PLEASE UPLOAD THE FILE WITH ONLY ONE SHEET', type: 'error' });
            }
        };
        reader.readAsBinaryString(file);
        this.fileUpload.nativeElement.value = '';
    }

    saveFile() {
        if (!this.excelData || this.clientList.length === 0) {
            swal({ title: 'ERROR', text: 'Please upload an Excel file first', type: 'error' });
            return;
        }
        if (!this.promoName || this.promoName.trim() === '') {
            swal({ title: 'ERROR', text: 'Please enter Promo Name', type: 'error' });
            return;
        }
        if (!this.assignEmpId) {
            swal({ title: 'ERROR', text: 'Please select Assign To', type: 'error' });
            return;
        }
        if (this.assignToCtrl.errors && this.assignToCtrl.errors['inValidAssignTo']) {
            swal({ title: 'ERROR', text: 'Select a valid employee from the Assign To list', type: 'error' });
            return;
        }
        this.isLoading = true;
        const that = this;
        const params = {
            data: this.excelData,
            promo_name: this.promoName.trim(),
            assign_emp_id: this.assignEmpId || 0
        };
        this.isLoadMask = this.campPromoUploadService
            .saveCampPromoExcelData(params)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.excelData = '';
                    that.rawFile = null;
                    // that.rawFileBase64 = '';
                    that.rawFileName = '';
                    that.promoName = '';
                    that.assignEmpId = 0;
                    that.assignToCtrl.setValue('');
                    that.clientList = [];
                    swal({ title: 'Success', html: that.buildResultHtml(res.message, res.errors), type: 'success' });
                } else {
                    swal({ title: 'ERROR', html: that.buildResultHtml(res.message, res.errors), type: 'error' });
                }
            }).catch(() => {
                that.isLoading = false;
                swal({ title: 'ERROR', text: 'An error occurred while saving', type: 'error' });
            });
    }

    buildResultHtml(message: string, errors: string[]): string {
        let html = `<p style="margin-bottom:8px;">${message}</p>`;
        if (errors && errors.length > 0) {
            html += `<div style="max-height:300px;overflow-y:auto;text-align:left;border:1px solid #ddd;border-radius:4px;padding:6px 10px;">`;
            errors.forEach((err, i) => {
                html += `<div style="padding:5px 0;border-bottom:1px solid #eee;color:#dc3545;font-size:15px;font-weight:bold;">${i + 1}. ${err}</div>`;
            });
            html += `</div>`;
        }
        return html;
    }

    fileData() {
        if (!this.excelData) {
            return true;
        }
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/campPromoUpload/campPromoUpload.component.ts